import TimeSafeOffer from "./apiTimeSafeOffer";
import ID from "./apiNextId";
import Quote from "./apiQuote";
import Templates from "./apiTemplates";
import Workgroups from "./apiWorkgroups";
import Customer from "./apiCustomer";
import Settings from "./apiSettings";
import TimeSafeFunctions from "./apiTimesafeFunctions";
import TimeSafeProjectPhases from "./apiTimesafeProjectPhases";
import TimeSafeMaterialTypes from "./apiTimesafeMaterialTypes";

/**
 * All API endpoints for Thanos
 */
export default {
    ID,
    Quote,
    Templates,
    TimeSafeOffer,
    Workgroups,
    Customer,
    Settings,
    TimeSafeFunctions,
    TimeSafeProjectPhases,
    TimeSafeMaterialTypes
};
